import { useState, useEffect, useMemo } from 'react'

const useWindowDimension = () => {
	const [windowSize, setWindowSize] = useState({
		width: undefined
	})

	const isResponsive = useMemo(() => windowSize.width < 1200, [windowSize])

	const isMedium = useMemo(() => windowSize.width < 960, [windowSize])

	const isIpad = useMemo(() => windowSize.width < 769, [windowSize])

	const isMobile = useMemo(() => windowSize.width < 576, [windowSize])

	useEffect(() => {
		if (typeof window !== 'undefined') {
			function handleResize() {
				setWindowSize({
					width: window.innerWidth
				})
			}
			window.addEventListener('resize', handleResize)
			handleResize()
			return () => window.removeEventListener('resize', handleResize)
		}
	}, []) // Empty array ensures that effect is only run on mount

	return {
		windowSize,
		isResponsive,
		isMedium,
		isIpad,
		isMobile
	}
}

export default useWindowDimension
